<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>老师上课记录</Breadcrumb-item>
        <Breadcrumb-item>差评投诉列表</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="60" :show-message="false">
        <Row :gutter="12">
          <Col :xs="12" :sm="16" :md="10" >
          </Col>
          <Col :xs="12" :sm="8" :md="5">
          <Form-item label="课程类型" :label-width="75">
            <Select v-model.number="queryParam.lsnType" placeholder="全部"
                    @on-change="search" clearable>
              <Option v-for="item in $constant.bookLessonOpenedLsnType"
                      :value="item.code" :key="item.code">{{ item.text }}</Option>
            </Select>
          </Form-item>
          </Col>
          <Col :xs="12" :sm="8" :md="4">
          <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                  @click="search" >搜索
          </Button>
          </Col>
        </Row>
      </Form>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/bc/listNegativeComment"
          :params="queryParam" :onLoading="onLoading" operator=""></List>
    <other-reason-modal :otherReason="otherReason" v-model="ohterReasonModal"></other-reason-modal>
  </div>
</template>
<script>
  import OtherReasonModal from './OtherReasonModal.vue'
  export default {
    components: {OtherReasonModal},
    data () {
      let $constant = this.$constant
      return {
        searchLoading: false,
        exportLoading: false,
        reload: 0,
        reason: '',
        ohterReasonModal: false,
        otherReason: '',
        queryParam: {
          tchId: '',
          uid: '',
          userNickname: '',
          adminNickname: '',
          lessonStartTime: '',
          lessonEndTime: '',
          lsnType: '',
        },
        title: [
          {
            title: '学生姓名/ID',
            render: (h, params) => {
              let row = params.row
              return h('span', row.nickName + '-' + row.uid)
            }
          },
          {
            title: '课程名称',
            key: 'lessonName',
          },
          {
            title: '课程类型',
            render: (h, params) => {
              let lsnType = params.row.lsnType
              let typeEnum = $constant.getEnum($constant.bookLessonOpenedLsnType, lsnType)
              return h('span', typeEnum && typeEnum.text)
            }
          },
          {
            title: '课程开始时间时间',
            key: 'lessonStartTime'
          },
          {
            title: '投诉理由',
            align: 'center',
            render: (h, params) => {
              let reason = params.row.complaintReason
              let typeEnum = $constant.getEnum($constant.complaintReason, reason)
              return h('span', typeEnum && typeEnum.text)
            }
          },
          {
            title: '投诉补充',
            render: (h, params) => {
              let row = params.row
              if (row.otherComplaintReason) {
                return h('a', {on: {click: () => this.showReason(row.otherComplaintReason)}}, '查看')
              } else {
                return h('span', '无')
              }
            }
          },
        ]
      }
    },
    mounted: function () {
    },
    created: function () {
      this.queryParam.tchId = localStorage.tchId
      this.queryParam.lessonStartTime = localStorage.startTime
      this.queryParam.lessonEndTime = localStorage.endTime
    },
    methods: {
      showReason (reason) {
        this.otherReason = reason
        this.ohterReasonModal = true
      },
      search () {
        this.reload = new Date().getTime()
      },
      onLoading (loading) {
        this.searchLoading = loading
      },
    }
  }

</script>



// WEBPACK FOOTER //
// NegativeComment.vue?12ea7110